export default __webpack_public_path__ + "static/media/trips.80c8ac4d.svg";